import MobileSearchBar from './mobile-search-bar'

export default MobileSearchBar
